import { UI_Anchor } from 'ui/components/2-molecules/Anchor/Anchor';

interface Props {
	content: {
		properties: {
			className: string;
			anchorName: string;
		};
	};
}

export const Anchor = ({ content }: Props) => {
	const { anchorName } = content?.properties ?? {};

	return <UI_Anchor {...content?.properties} anchorId={anchorName ? anchorName.toLowerCase().replace(/ /g, '_') : ''} />;
};
